import auth from './../common/auth'

export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_ERROR = 'LOGIN_ERROR'
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS'

const logIn = () => async dispatch => {
	try {
		await auth.login()
		dispatch({ type: LOGIN_SUCCESS })
	} catch (e) {
		dispatch(logInError(e))
	}
}

const logOut = () => async dispatch => {
	await auth.logout('/', true)
	dispatch({ type: LOGOUT_SUCCESS })
}

const logInError = error => ({
	type: LOGIN_ERROR,
	error: error
})

export { logIn, logOut }



// WEBPACK FOOTER //
// ./src/actions/auth.js